import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  cuenta_selected: {}, //seleccionara el objeto de la lista de magistrados
  cuentas: [],
  cuentas_sesion: [],
  currentCuenta: {}
  // currentCuenta: JSON.parse(localStorage.getItem("currentCuenta")) || ''
};
export const mutations = {
  SELECT_CUENTA({ context }, cuenta) {
    return (state.cuenta_selected = Object.assign({}, cuenta));
  },
  FILL_CUENTAS({ context }, list_cuentas) {
    let cuentas = [];
    Object.entries(list_cuentas).forEach(([key, val]) => cuentas.push(val));
    return (state.cuentas = cuentas);
  },
  // FILL_CUENTAS_SESION({ context }, list_cuentas_sesion) {
  //   let cuentas_sesion = [];
  //   Object.entries(list_cuentas_sesion).forEach(([key, val]) => cuentas_sesion.push(val));
  //   return (state.cuentas_sesion = cuentas_sesion);
  // },
  SHOW_CUENTA ({ context }, cuenta) {
    state.currentCuenta = cuenta.id;
    // localStorage.setItem("currentCuenta", JSON.stringify(state.currentCuenta));
  }
};

export const actions = {
  GET_CUENTAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response)
          commit("FILL_CUENTAS", response.data.data.cuentas.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  GET_CUENTAS_SESION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
         // commit("FILL_CUENTAS", response.data.data.cuenta);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  UPDATE_CUENTA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.put(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  CREATE_OBSERVACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.put(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  DELETE_ITEM({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.delete(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SHOW_CUENTA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("SHOW_CUENTA", response.data.data.cuenta);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  // CREATE_APELACION({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true); //este loadin esta en el index principalde store
  //     ApiService.guardar(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  // },

};
export const getters = {
  getAllCuentas: state => {
    return state.cuentas;
  },
  getCuentaSelected: state => {
    return state.cuenta_selected;
  },
  currentCuenta: state => {
    return state.currentCuenta;
  },
};
